"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiImpacteesParTrads = void 0;
exports.ESubScpiImpacteesParTrads = {
    desDeux: "Des deux",
    evolutionLoyer: "L'évolution des loyers",
    evolutionMarcheImmo: "L'évolution du marché immobilier",
};
